<template>
    <!-- 空间 -->
    <div class="space_warp">
        <BasePage ref="basePage">
            <template scope="{item}">
                <div class="item_box" @click="toDetail(item)">
                    <img class="item_img" :src="item.image" >
                    <div class="item_info">
                        <div class="item_title ellipsis">{{item.title}}</div>
                        <div class="bot">
                            <span style="margin-right:auto">浏览 {{0}}</span>
                            <svg-icon icon-class="comment" class-name="card-panel-icon" />
                            <span style="margin-right:7px">{{item.scs || 0}}</span>
                            <svg-icon icon-class="thumb" class-name="card-panel-icon" />
                            <span>{{item.dzs || 0}}</span>
                        </div>
                        <div class="item_footer">
                            <img class="item_footer_icon" :src="item.venueLogo" >
                            <span style="margin-right:auto">{{item.venueName}}</span>
                        </div>
                    </div>
                </div>
            </template>
        </BasePage>
    </div>
</template>

<script>
import BasePage from '@c/BasePage'
export default {
    name: 'space',
    components: {
        BasePage
    },
    data () {
        return {

        }
    },
    beforeRouteUpdate(to, from, next) {
        this.$refs.basePage.loadImage(to.query.id)
        next()
    },
    methods: {
        toDetail(item) {
            this.$router.push(`/space/detail/${item.id}`)
        }
    }
}
</script>

<style scoped lang="scss">
.space_warp {
    background: #f8f8f8;
    .item_box {
        width: 285px;
        margin: 0 20px 20px 0;
        background: #fff;
        box-shadow: 0 10px 18px 0 rgba(0,0,0,.05);
        border-radius: 5px;
        cursor: pointer;
        overflow: hidden;
        &:nth-child(4n) {
            margin-right: 0;
        }
        .item_img {
            width: 100%;
            height: 132px;
            object-fit: cover;
        }
        .item_info {
            padding: 18px;
            line-height: 1;
        }
        .item_title {
            font-size: 18px;
            color: #000;
        }
        .item_icon {
            width: 16px;
            height: 16px;
            margin-right: 7px;
        }
        .bot {
            display: flex;
            align-items: center;
            color: #c0c0c0;
            margin: 15px 0 25px;
        }
        .item_footer {
            font-size: 14px;
            display: flex;
            align-items: center;
            color: #777;
        }
        .item_footer_icon {
            width: 32px;
            height: 32px;
            margin-right: 7px;
            overflow: hidden;
            border-radius: 50%;
        }
        .card-panel-icon {
            font-size: 16px;
            margin-right: 7px;
        }
    }
}
</style>